export const sensitiveQueryPolicy = {
  staleTime: 0,
  gcTime: 0,
  refetchOnMount: "always",
  refetchOnWindowFocus: "always",
  refetchOnReconnect: "always",
} as const;

export const historyQueryPolicy = {
  staleTime: 10_000,
  gcTime: 60_000,
} as const;

export const catalogQueryPolicy = {
  staleTime: 60_000,
  gcTime: 5 * 60_000,
} as const;

// 会话仅供 UI 展示；路由之间短期共享读取，不作为服务端鉴权快照。
export const sessionQueryPolicy = {
  staleTime: 30_000,
  gcTime: 0,
  refetchOnWindowFocus: "always",
  refetchOnReconnect: "always",
} as const;

export function privateQueryKey(family: string, userId: string | undefined, ...params: readonly unknown[]) {
  return [family, "account", userId, ...params] as const;
}

export async function clearPrivateQueries(client: QueryClient, keepAccount?: string) {
  // 限定本次清理开始时的对象，避免异步取消结束后删掉刚切换账号创建的查询。
  const targets = new Set(client.getQueryCache().findAll({ predicate: (query) =>
    query.queryKey[1] === "account" && (keepAccount === undefined || query.queryKey[2] !== keepAccount) }));
  const filters: QueryFilters = { predicate: (query) => targets.has(query) };
  await client.cancelQueries(filters);
  client.removeQueries(filters);
}

// 刷新期间保留上次结果（仅错误时收敛为空）：数字区以「旧值 + 局部刷新指示」呈现，
// 避免轮询、窗口聚焦等后台 refetch 把已展示的金额/表格整块清空。同 key 的旧值必然
// 属于同一账号与同一筛选参数，不构成跨身份串读。
export function freshFinancialData<T>(query: { data: T | undefined; isFetching: boolean; isError: boolean }): T | undefined {
  return query.isError ? undefined : query.data;
}
import type { QueryClient, QueryFilters } from "@tanstack/react-query";
import { ApiError } from "./api";

export function transientTaskReadError(error: unknown): boolean {
  return !(error instanceof ApiError) || error.status === 408 || error.status === 429 || error.status >= 500;
}

export const liveTaskReadPolicy = {
  retry: (failureCount: number, error: unknown) => failureCount < 4 && transientTaskReadError(error),
  retryDelay: 1_000,
} as const;
